import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { pageStyles } from "./pageStyles";
import NavBar from "./NavBar";

export default function SignupPage() {
  const { signup } = useAuth();
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setSubmitting(true);
    try {
      const result = await signup(email, displayName);
      setMessage(result.message);
    } catch (err) {
      setError(err.message || "Could not create account.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={pageStyles.page}>
      <NavBar />
      <div style={pageStyles.authWrap}>
        <form style={pageStyles.card} onSubmit={handleSubmit}>
          <h1 style={pageStyles.title}>Create an account</h1>
          <p style={pageStyles.subtitle}>Free — verify your email to activate your account.</p>

          <label style={pageStyles.label} htmlFor="signup-name">Name</label>
          <input
            id="signup-name"
            type="text"
            autoComplete="name"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            style={pageStyles.input}
          />

          <label style={pageStyles.label} htmlFor="signup-email">Email</label>
          <input
            id="signup-email"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={pageStyles.input}
          />

          {error ? <div style={pageStyles.errorBanner}>{error}</div> : null}
          {message ? <div role="status" style={pageStyles.successBanner}>{message}</div> : null}

          <button
            type="submit"
            disabled={submitting}
            style={{ ...pageStyles.button, ...(submitting ? pageStyles.buttonDisabled : {}) }}
          >
            {submitting ? "Submitting…" : message ? "Resend verification link" : "Create account"}
          </button>

          <div style={pageStyles.linkRow}>
            <Link to="/forgot-password" style={pageStyles.link}>Forgot password?</Link>
            <Link to="/login" style={pageStyles.link}>Already have an account? Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
